var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C21.0623 29.9277 18.1836 29.1601 15.6 27.76C12.7548 26.2809 10.157 24.368 7.9 22.09C5.62331 19.838 3.71349 17.2432 2.24 14.4C0.838853 11.8168 0.0711271 8.93785 0 6C0 4.28 1.61 2.61 2.29 2C3.29 1.09 4.85 0 5.98 0C6.78934 0.126671 7.5269 0.538006 8.06 1.16C8.81408 1.87368 9.50654 2.64977 10.13 3.48C10.57 4.03 12.73 6.88 12.73 8.25C12.73 9.37 11.46 10.15 10.12 10.97C9.62167 11.2761 9.14091 11.61 8.68 11.97C8.27 12.3 8.19 12.48 8.18 12.52C10.1405 16.5835 13.4281 19.857 17.5 21.8C17.5 21.8 17.71 21.72 18.05 21.3C18.3963 20.8402 18.7136 20.3593 19 19.86C19.83 18.52 20.61 17.25 21.73 17.25C23.1 17.25 25.94 19.41 26.5 19.85C27.3302 20.4735 28.1063 21.1659 28.82 21.92C29.4494 22.4499 29.8681 23.1879 30 24C30 25.14 28.93 26.7 28 27.7C27.37 28.39 25.7 30 24 30Z",
    fill: "#CB34FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.5221868aebf29f0daae4db4e2309b899.svg";
export { ForwardRef as ReactComponent };